import { useEffect, useRef } from "react";
import { useField } from "react-final-form";

import { LayerClassification } from "fond/types";

/**
 * Hook to watch for attribute changes and clear classifications when the attribute changes.
 * This prevents stale classification data from being associated with the wrong attribute.
 */
export const useClearClassificationsOnAttributeChange = () => {
  const previousAttributeIdRef = useRef<string | undefined>(undefined);
  const {
    input: { onChange: setLayerClassifications, value: layerClassifications },
  } = useField<LayerClassification[]>("layerClassifications");
  const {
    input: { value: attributeId },
  } = useField<string>("attributeId");

  useEffect(() => {
    const currentAttributeId = attributeId;
    const previousAttributeId = previousAttributeIdRef.current;

    // Initialize on first render
    if (previousAttributeId === undefined && currentAttributeId) {
      previousAttributeIdRef.current = currentAttributeId;
      return;
    }

    // Clear classifications if attributeId changed
    if (currentAttributeId !== previousAttributeId && previousAttributeId !== undefined) {
      previousAttributeIdRef.current = currentAttributeId;
      if (layerClassifications.length > 0) {
        setLayerClassifications([]);
      }
    }
  }, [attributeId, layerClassifications.length, setLayerClassifications]);
};
